<template>
    <div>
        <div class="text" ref="text" :class="{'expanded':!popperOpen}" v-html="privateData.text[store.lang]"></div>
        <div v-show="isReadMore" @click="expand" ref="read_more" class="read-more" :class="{'d-none': !popperOpen}">{{ lang('read_more') }} <i class="fas fa-chevron-down"></i></div>
    </div>
</template>

<script>
import { store } from '../store.js'

export default {
    name: 'Text',
    props: ['popperOpen'],
	inject: ['lang'],
    data() {
        return {
            privateData: {
                text: '',
            },
            isReadMore: false,
			store
        };
    },
    created() {
        this.$watch('$readMore.value', (newVal) => {
            this.privateData.text = newVal;
        }, { immediate: true });
    },
    mounted() {
    	if (this.$refs.text.scrollHeight > 150) {
    		this.isReadMore = true;
    	}

        this.privateData.text = this.$readMore.value;
    },
    methods: {
        expand(event) {
            this.expandText();
            this.hideReadMore();
        },
        collapse() {
            this.collapseText();
            this.showReadMore();
        },
        expandText() {
            this.$refs.text.classList.add('expanded');
        },
        collapseText() {
            this.$refs.text.classList.remove('expanded');
        },
        showReadMore() {
            this.$refs.read_more.classList.remove('d-none');
        },
        hideReadMore() {
            this.$refs.read_more.classList.add('d-none');
        }
      }
}
</script>

<style lang="scss" scoped>
.text {
  @media(max-width: 600px) {
    font-size: 16px;
  }
  @media(max-width: 400px) {
    font-size: 14px;
  }
}
</style>
